
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"110","height":"130","viewBox":"0 0 29.104 34.396","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256.031 429.53l-54.171-31.277-54.172-31.275 54.172-31.276 54.171-31.276v62.552z","transform":"matrix(-.19239 0 0 .26135 53.339 -78.713)","fill":"#f5f5f5","stroke":"#f5f5f5"}})])
          )
        }
      }
    